import { render, staticRenderFns } from "./DownloadVideos.vue?vue&type=template&id=38ab25ca&"
import script from "./DownloadVideos.vue?vue&type=script&lang=js&"
export * from "./DownloadVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports